import { Observable } from "rxjs/Observable";
import { addNotification as notify } from "reapop";
import * as NotificationsActionCreators from "../common/notification";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/mapto";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as ErrorHandler from "../common/errorHandler";
import * as DTOS from "../FeralScan.dtos";
import { serviceApi } from "../services/user.service";
import * as Configuration from '../configuration';
import { push } from 'connected-react-router';

import {
    IUserActions,
    CURRENT_USER_REQUEST,
    CURRENT_USER_SUCCESS,
    REGISTER_USER_REQUEST,
    SEND_PASSWORD_RESET_REQUEST,
    CHANGE_PASSWORD_TOKEN_REQUEST,
    IS_VALID_CHANGE_PASSWORD_TOKEN,
    CHANGE_PASSWORD_TOKEN_SUCCESS,
    SEND_ACTIVATE_ACCOUNT_REQUEST,
    ACTIVATE_ACCOUNT_REQUEST,
    getCurrentUserRequestSuccess,
    getCurrentUserRequest,
    activateAccountSuccess,
    registerUserSuccess,
    IRegisterUserRequestAction,
    IUpdateUserRequestAction,
    updateUserSuccess,
    UPDATE_USER_REQUEST,
    updateUserFailure,
    UPDATE_USER_PREFERENCES_REQUEST,
    IUpdateUserPreferencesRequestAction,
    updateUserPreferencesSuccess,
    IChangePasswordRequestAction,
    CHANGE_PASSWORD_REQUEST,
    IAssignUserRoleRequestAction,
    assignUserRoleSuccess,
    ASSIGN_USER_ROLE_REQUEST,
    UNASSIGN_USER_ROLE_REQUEST,
    IUnassignUserRoleRequestAction,
    unassignUserRoleSuccess,
    assignUserRoleFailure,
    unassignUserRoleFailure,
    EMAIL_OPT_OUT_REQUEST,
    IEmailOptOutRequest,
    emailOptOutFailure,
} from "../actions/user.actions";

import {
    login
} from "../actions/login.actions";

export const getCurrentUser = action$ =>
    action$
        .ofType(CURRENT_USER_REQUEST)
        .mergeMap((action: IUserActions) =>
            serviceApi
                .getCurrentUser()
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getCurrentUserRequestSuccess(response))
                    )
                })
                .catch((error: DTOS.GetUserResponse) => ErrorHandler.FireErrorActions(error))
        );

/*export const getCurrentUserSuccess = action$ =>
    action$
        .ofType(CURRENT_USER_SUCCESS)
        .mergeMap((action: IUserActions) =>
            concat$(
            ));*/

export const registerUser = action$ =>
    action$
        .ofType(REGISTER_USER_REQUEST)
        .mergeMap((action: IRegisterUserRequestAction) =>
            serviceApi
                .registerUser(action.user)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("", `Please verify your email to complete registration.`));
                    return concat$(
                        Observable.of(registerUserSuccess())
                        , Observable.of(notification)
                        , Observable.of(push('/'))
                        //,Observable.of(login(response.user.email, action.user.password))
                    );
                })
                .catch(error => {
                    return concat$(
                        Observable.of(registerUserSuccess())
                        , ErrorHandler.FireErrorActions(error)
                    )
                })
        );

export const updateUser = action$ =>
    action$
        .ofType(UPDATE_USER_REQUEST)
        .mergeMap((action: IUpdateUserRequestAction) =>
            serviceApi
                .updateUser(action.user)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("", `Sucessfully updated.`));
                    return concat$(
                        Observable.of(updateUserSuccess(response.user))
                        , Observable.of(notification)
                    );
                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(updateUserFailure())
                    )
                })
        );

export const updateUserPreferences = action$ =>
    action$
        .ofType(UPDATE_USER_PREFERENCES_REQUEST)
        .mergeMap((action: IUpdateUserPreferencesRequestAction) =>
            serviceApi
                .updateUserPreferences(action.preferences)
                .mergeMap(response => {
                    //var notification = notify(NotificationsActionCreators.notifyInfo("", `Sucessfully updated user preferences.`));
                    return concat$(
                        Observable.of(updateUserPreferencesSuccess(response))
                        //, Observable.of(notification)
                    );
                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(updateUserFailure())
                    )
                })
        );

export const sendPasswordReset = action$ =>
    action$
        .ofType(SEND_PASSWORD_RESET_REQUEST)
        .mergeMap((action: IUserActions) =>
            serviceApi
                .sendPasswordReset(action.username)
                /*.mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("", `Password reset instructions have been sent to your email.`));
                    return concat$(
                        Observable.of(notification)
                    );
                })*/
                .catch(error => ErrorHandler.FireErrorActions(error))
        );

export const sendActivateAccount = action$ =>
    action$
        .ofType(SEND_ACTIVATE_ACCOUNT_REQUEST)
        .mergeMap((action: IUserActions) =>
            serviceApi
                .sendActivateAccount(action.username)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("", `Account activation instructions have been sent to your email.`));
                    return concat$(
                        Observable.of(notification)
                    );
                })
                .catch(error => ErrorHandler.FireErrorActions(error))
        );


export const activeAccount = action$ =>
    action$
        .ofType(ACTIVATE_ACCOUNT_REQUEST)
        .mergeMap((action: IUserActions) =>
            serviceApi
                .activateUserAccount(action.token)
                .mergeMap(response => {
                    var notification = response.accountActivated ? notify(NotificationsActionCreators.notifySuccess("", `Account activated.`)) : notify(NotificationsActionCreators.notifyDanger("", `Failed to activate user account.`));
                    return concat$(
                        Observable.of(notification),
                        Observable.of(activateAccountSuccess(response))
                    );
                })
                .catch(error => ErrorHandler.FireErrorActions(error))
        );

export const changePassword = action$ =>
    action$
        .ofType(CHANGE_PASSWORD_REQUEST)
        .mergeMap((action: IChangePasswordRequestAction) =>
            serviceApi
                .changePassword(action.newPassword)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifySuccess("", `Password successfully changed.`));
                    return concat$(
                        Observable.of(notification)
                    );
                })
                .catch(error => ErrorHandler.FireErrorActions(error))
        );

export const changeUserOptOutStatus = action$ =>
    action$
        .ofType(EMAIL_OPT_OUT_REQUEST)
        .mergeMap((action: IEmailOptOutRequest) =>
            serviceApi
                .changeUserOptOutStatus(action.optOutStatus)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifySuccess("", `Successfully updated program status.`));
                    return concat$(
                        Observable.of(notification)
                        , Observable.of(updateUserSuccess(response.user))
                    );
                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(emailOptOutFailure())
                    )
                })
        );

export const changePasswordFromToken = action$ =>
    action$
        .ofType(CHANGE_PASSWORD_TOKEN_REQUEST)
        .mergeMap((action: IUserActions) =>
            serviceApi
                .changePasswordFromToken(action.token, action.newPassword)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifySuccess("", `Password successfully changed.`));
                    return concat$(
                        Observable.of(notification),
                        Observable.of(login(response.user.email, action.newPassword, false))
                    );
                })
                .catch(error => ErrorHandler.FireErrorActions(error))
        );

export const isValidChangePasswordToken = action$ =>
    action$
        .ofType(IS_VALID_CHANGE_PASSWORD_TOKEN)
        .mergeMap((action: IUserActions) =>
            serviceApi
                .isValidChangePasswordToken(action.token)
                /*.mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("", `Password successfully changed.`));
                    return concat$(
                        Observable.of(notification)
                    );
                })*/
                .catch(error => ErrorHandler.FireErrorActions(error))
        );


export const assignUserRole = action$ =>
    action$
        .ofType(ASSIGN_USER_ROLE_REQUEST)
        .mergeMap((action: IAssignUserRoleRequestAction) =>
            serviceApi
                .assignUserRole(action.userId, action.roleId, action.plotId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(assignUserRoleSuccess(response))
                    );
                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(assignUserRoleFailure())
                    )
                })
        );

export const unassignUserRole = action$ =>
    action$
        .ofType(UNASSIGN_USER_ROLE_REQUEST)
        .mergeMap((action: IUnassignUserRoleRequestAction) =>
            serviceApi
                .unassignUserRole(action.userRoleId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(unassignUserRoleSuccess(response))
                    );
                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(unassignUserRoleFailure())
                    )
                })
        );
